import axios from 'axios';
import useSiteState from '@app/state/SiteState';
import SecurityService from '@app/model/_security/service/SecurityService';


export class HttpService {

    private static headers() {
        const state = useSiteState.getState();
        return !!SecurityService.getToken() ?  {
            'Authorization': `Bearer ${SecurityService.getToken() ?? undefined}`,
        } : {}
    }

    private static url(url: string) {
        return process.env.REACT_APP_API_URL + (url.startsWith("/") ? url : "/" + url);
    }

    private static objToFormData(obj: any): FormData {
        const formData = new FormData();
        for (const key in obj) {
            formData.append(key, obj[key]);
        }
        return formData;
    }

    public static get<T = any>(url: string): Promise<T> {
        return axios.get<T>(this.url(url), {
            headers: this.headers()
        }).then(response => response.data);
    }

    public static post<T = any>(url: string, data: any): Promise<T> {
        return axios.post<T>(this.url(url), data, {
            headers: this.headers()
        }).then(response => response.data);
    }

    public static multipart<T = any>(url: string, data: any): Promise<T> {
        return axios.post<T>(this.url(url), this.objToFormData(data), {
            headers: this.headers()
        }).then(response => response.data);
    }

    public static getBlob(url: string): Promise<Blob> {
        // For binary responses like Excel files
        return axios.get(this.url(url), {
            headers: this.headers(),
            responseType: 'blob'
        }).then(res => res.data);
    }
}
